import {
    Button,
    Col,
    Row,
    Badge,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import { DatePicker } from "antd";
import moment from "moment";
import { Filter } from "react-feather";
import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import api from "../../../../../service/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";

export const Search = ({
    setSearchValue,
    searchValue,
    search,
    generateReport,
    companyName,
    setCompanyName,
}) => {
    const [hasMore, setHasMore] = useState(true);
    const handleLoadMore = async (search, { page }) => {
        if (!search) {
            return {
                options: [],
                hasMore: false,
            };
        }
        const response = await api.get("tms/companies-options", {
            search: search,
            page: page,
        });
        const { options: newOptions, hasMore: newHasMore } = response;
        setHasMore(newHasMore);
        return {
            options: newOptions,
            hasMore: newHasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    return (
        <div className="mb-3">
            <Row className="g-2 align-items-center">
                {/* From Date */}
                <Col md={2}>
                    <DatePicker
                        id="from-date-picker"
                        value={searchValue.start_date ? moment(searchValue.start_date, "YYYY-MM-DD") : null}
                        name="from_date"
                        className="form-control"
                        placeholder="From date"
                        onChange={(e) =>
                            setSearchValue({
                                ...searchValue,
                                start_date: e
                                    ? moment(e).format("YYYY-MM-DD")
                                    : null,
                            })
                        }
                    />
                </Col>

                {/* "To" Badge */}
                <Col md="auto" className="text-center">
                    <Badge bg="info" className="px-3 py-2">
                        To
                    </Badge>
                </Col>

                {/* To Date */}
                <Col md={2}>
                    <DatePicker
                        id="to-date-picker"
                        name="to_date"
                        className="form-control"
                        value={searchValue.end_date ? moment(searchValue.end_date, "YYYY-MM-DD") : null}

                        placeholder="To date"
                        onChange={(e) =>
                            setSearchValue({
                                ...searchValue,
                                end_date: e
                                    ? moment(e).format("YYYY-MM-DD")
                                    : null,
                            })
                        }
                    />
                </Col>

                {/* Company Select */}
                <Col md={4}>
                    <AsyncPaginate
                        className="render-above"
                        isClearable
                        loadOptions={handleLoadMore}
                        hasMore={hasMore}
                        placeholder="Search company"
                        additional={{ page: 1 }}
                        onChange={(value) => {
                            setSearchValue({
                                ...searchValue,
                                company: value ? value.value : "",
                            });
                            setCompanyName(value ? value.label : "");
                        }}
                    />
                </Col>

                {/* Search Button */}
                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-search">Search filter</Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            onClick={(e) => {
                                e.preventDefault();
                                search({ page: 1 });
                            }}
                            title="Search filter"
                            className="me-2"
                        >
                            <Filter size={15} />
                        </Button>
                    </OverlayTrigger>
                </Col>

                {/* Export Button */}
                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-export">
                                Export Unpaid Invoices
                            </Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            title="Export Unpaid Invoices"
                            onClick={() => generateReport()}
                        >
                            <FontAwesomeIcon icon={faFileExport} />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Row>
        </div>
    );
};
